/**
 * /tenants/$tenantId/brand — platform-side tenant branding edit (LADM-08).
 *
 * Phase 6 Plan 07. Linkco staff land here from the tenant LIST row's
 * "Brand" action button. The screen composes `<BrandStudio>` against the
 * MSW-bridged `useUpdatePlatformBranding` hook (Plan 06-07).
 */
import { createFileRoute } from "@tanstack/react-router";
import { TenantBrandingScreen } from "../features/tenants/TenantBrandingScreen";

export const Route = createFileRoute("/_auth/tenants/$tenantId/brand")({
  staticData: {
    breadcrumb: { labelKey: "link-admin:branding.title" },
  },
  component: TenantBrandingScreen,
});
